<div [class.show]="navBarToggledClass" id="sidenav">
    <button (click)="showHideSideNav()" class="toggle"></button>

    <div class="inner">
        <div class="header">
            <div class="logo">
                <a [routerLink]='"/dashboard"'><img alt="Lobster Experience & Loop Plus Logo" src="/assets/logos/lobster-loop-plus.svg"/></a>
            </div>

            <ul class="sidenav-menu">
                <ng-container *ngFor="let item of sidenav">
                    <li class="label">{{ item.label }}</li>
                    <li *ngFor="let element of item.items" class="sidenav-menu-link">

                        @if (element.routerLink) {
                            <a href="{{ element.routerLink }}" target="{{ element.target }}"><i class="{{ element.icon }}"></i> <span>{{ element.label }}</span></a>
                        } @else {
                            <a href="javascript:void(0)" (click)="executeCommand(element)" [class]="getElementClass(element)">
                                <i [class]="element.icon"></i>
                                <span>{{ getElementLabel(element) }}</span>
                            </a>
                        }
                    </li>
                </ng-container>
            </ul>
        </div>

        <div class="footer">
            <div class="version">Version {{ env.version }}<br>{{ env.buildDate | date: 'medium' }}</div>

            <app-meta-nav></app-meta-nav>

            <div class="lang-logout">
                <a class="lang" href="{{ langSwitchUri }}"><i class="fa-regular fa-arrows-rotate"></i>  {{ langSwitch | uppercase }}</a>
                <a
                    (click)="logout()"
                    class="logout"
                    pTooltip="Logout"
                    tooltipPosition="right"
                ><i class="fa-regular fa-arrow-right-from-bracket"></i
                ></a>
            </div>
        </div>
    </div>
    <!-- /.inner -->
</div>
